<template>
  <div class="main">
    

    <a-card :loading="tableLoading" style="border-radius: 20px;" :bordered="false">
    
      <div class="actions">
      <h3 style="font-size: 28px; line-height: 45px">Quotation</h3>
      <div>
        <a-button @click="showAddBackOrderModal" style="
              border-raduis: 5px;
            " icon="plus">
          Add Quotation
        </a-button>
      </div>
    </div>
    <div class="card-container mt-5">
      <a-tabs type="card">
        <a-tab-pane key="1">
          <span slot="tab">
            All Quotation
          </span>
          <div class="requestActions">
            <!-- <a-form-model
              :model="orderform"
            >
                <a-form-model-item>
                    <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                        <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                    </a-input>
                </a-form-model-item>
            </a-form-model> -->


            <div>
              <a-button @click="exportAllOrders" style="
                  height: 38px;
                  border-raduis: 5px;
                  background: #418a49;
                  color: #fff;
                " icon="export">
                Export
              </a-button>
            </div>
          </div>
          <div>
            <a-table :columns="columns" :scroll="{ x: 1500 }" :data-source="tableAllOrdersData" :loading="tableLoading"
              :pagination="pagination" class="tableStyle">
              <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <div slot="filterDistributionCenterDropdown"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <div slot="filterStatusDropdown" slot-scope="{ clearFilters }"
                style="padding: 8px;display: flex;flex-direction: column;">
                <a-select style="width: 190px" @change="e => onInventoryChange(e, clearFilters)">
                  <a-select-option value="all">
                    All
                  </a-select-option>
                  <a-select-option value="0">
                    New
                  </a-select-option>
                  <a-select-option value="1">
                    AwaitingConfirmation
                  </a-select-option>
                  <a-select-option value="2">
                    Firmed
                  </a-select-option>
                  <a-select-option value="3">
                    Fulfilling
                  </a-select-option>
                  <a-select-option value="4">
                    Complete
                  </a-select-option>
                  <a-select-option value="5">
                    Canceled
                  </a-select-option>
                </a-select>
              </div>

              <template slot="action" slot-scope="order">
                <a-dropdown>
                  <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                    <a-icon style="font-size: 25px" type="ellipsis" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a @click="showMoreDetailsModal(order)">More Details?</a>
                    </a-menu-item>
                    <!-- <a-menu-item v-if="order.status === 0">
                      <a @click="updateBackOrderStatus(order, 1)"
                        >Move to awaiting confirmation</a
                      >
                    </a-menu-item>
                    <a-menu-item v-else-if="order.status === 1">
                      <a @click="updateBackOrderStatus(order, 2)"
                        >Confrim  Product Line</a
                      >
                    </a-menu-item> -->
                    <!-- <a-menu-item v-else-if="order.status === 2">
                      <a @click="updateBackOrderStatus(order, 3)"
                        >Move to fulfilling</a
                      >
                    </a-menu-item> -->
                    <!-- <a-menu-item v-else-if="order.status === 3">
                      <a @click="updateBackOrderStatus(order, 4)"
                        >Complete Order</a
                      >
                    </a-menu-item> -->
                    <a-menu-item v-if="order.statusLabel === 'AwaitingConfirmation'">
                      <a @click="updateBackOrderStatus(order, 2)">Firm Up Order</a>
                    </a-menu-item>

                    <a-menu-item v-if="showCreateFullfillmentActions(order)">
                      <a @click="handleFulfillmentModal(order)">Create Fulfillments</a>
                    </a-menu-item>

                    <a-menu-item v-if="showCompleteOrderActions(order)">
                      <a @click="updateBackOrderStatus(order, 4)">Complete Order</a>
                    </a-menu-item>

                    <a-menu-item v-if="showDeclinedActions(order)">
                      <a @click="showSureModal(order)">Decline this Order?</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </template>
              <template slot="status" slot-scope="data">
                <status-component :status="data"></status-component>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2">
          <span slot="tab">
            New Quotation
          </span>
          <div class="requestActions">
            <a-button @click="exportNewOrders" style="
                height: 38px;
                border-raduis: 5px;
                background: #418a49;
                color: #fff;
              " icon="export">
              Export
            </a-button>
          </div>
          <div>
            <a-table :columns="columnsStatues" :scroll="{ x: 1500 }" :data-source="tableNewOrdersData" :loading="tableLoading"
              :pagination="pagination" class="tableStyle">
              <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <div slot="filterDistributionCenterDropdown"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <template slot="action" slot-scope="order">
                <a-dropdown>
                  <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                    <a-icon style="font-size: 25px" type="ellipsis" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a @click="showMoreDetailsModal(order)">More Details?</a>
                    </a-menu-item>
                    <!-- <a-menu-item v-if="order.status === 0">
                      <a @click="updateBackOrderStatus(order, 1)"
                        >Move to awaiting confirmation</a
                      >
                    </a-menu-item>
                    <a-menu-item v-else-if="order.status === 1">
                      <a @click="updateBackOrderStatus(order, 2)"
                        >Confrim  Product Line</a
                      >
                    </a-menu-item>
                    <a-menu-item v-else-if="order.status === 2">
                      <a @click="updateBackOrderStatus(order, 3)"
                        >Move to fulfilling</a
                      >
                    </a-menu-item>
                    <a-menu-item v-else-if="order.status === 3">
                      <a @click="updateBackOrderStatus(order, 4)"
                        >Complete Order</a
                      >
                    </a-menu-item> -->
                    <a-menu-item v-if="showDeclinedActions(order)">
                      <a @click="showSureModal(order)">Decline this Order?</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </template>

              <template slot="status" slot-scope="data">
                <status-component :status="data"></status-component>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3">
          <span slot="tab">
            Awaiting Confirm...
          </span>
          <div class="requestActions">
            <a-button @click="exportAwaitingConfrimation" style="
                height: 38px;
                border-raduis: 5px;
                background: #418a49;
                color: #fff;
              " icon="export">
              Export
            </a-button>
          </div>
          <div>
            <a-table :columns="columnsStatues" :scroll="{ x: 1500 }" :data-source="tableAwaitingConfirmationOrdersData"
              :loading="tableLoading" :pagination="pagination" class="tableStyle">
              <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <div slot="filterDistributionCenterDropdown"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <template slot="action" slot-scope="order">
                <a-dropdown>
                  <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                    <a-icon style="font-size: 25px" type="ellipsis" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a @click="showMoreDetailsModal(order)">More Details?</a>
                    </a-menu-item>
                    <!-- <a-menu-item v-if="order.status === 0">
                      <a @click="updateBackOrderStatus(order, 1)"
                        >Move to awaiting confirmation</a
                      >
                    </a-menu-item>
                    <a-menu-item v-else-if="order.status === 1">
                      <a @click="updateBackOrderStatus(order, 2)"
                        >Confrim  Product Line</a
                      >
                    </a-menu-item>
                    <a-menu-item v-else-if="order.status === 2">
                      <a @click="updateBackOrderStatus(order, 3)"
                        >Move to fulfilling</a
                      >
                    </a-menu-item>
                    <a-menu-item v-else-if="order.status === 3">
                      <a @click="updateBackOrderStatus(order, 4)"
                        >Complete Order</a
                      >
                    </a-menu-item> -->
                    <a-menu-item v-if="order.statusLabel === 'AwaitingConfirmation'">
                      <a @click="updateBackOrderStatus(order, 2)">Firm Up Order</a>
                    </a-menu-item>
                    <a-menu-item v-if="showDeclinedActions(order)">
                      <a @click="showSureModal(order)">Decline this Order?</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </template>

              <template slot="status" slot-scope="data">
                <status-component :status="data"></status-component>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="4">
          <span slot="tab">
            Awaiting Fulfillment
          </span>
          <div class="requestActions">
            <a-button @click="exportFirmedOrders" style="
                height: 38px;
                border-raduis: 5px;
                background: #418a49;
                color: #fff;
              " icon="export">
              Export
            </a-button>
          </div>
          <div>
            <a-table :columns="columnsStatues" :scroll="{ x: 1500 }" :data-source="tableFirmedOrdersData" :loading="tableLoading"
              :pagination="pagination" class="tableStyle">
              <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <div slot="filterDistributionCenterDropdown"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <template slot="action" slot-scope="order">
                <a-dropdown>
                  <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                    <a-icon style="font-size: 25px" type="ellipsis" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a @click="showMoreDetailsModal(order)">More Details?</a>
                    </a-menu-item>
                    <!-- <a-menu-item v-if="order.status === 0">
                      <a @click="updateBackOrderStatus(order, 1)"
                        >Move to awaiting confirmation</a
                      >
                    </a-menu-item>
                    <a-menu-item v-else-if="order.status === 1">
                      <a @click="updateBackOrderStatus(order, 2)"
                        >Confrim  Product Line</a
                      >
                    </a-menu-item> -->
                    <!-- <a-menu-item v-else-if="order.status === 2">
                      <a @click="updateBackOrderStatus(order, 3)"
                        >Move to fulfilling</a
                      >
                    </a-menu-item> -->
                    <!-- <a-menu-item v-else-if="order.status === 3">
                      <a @click="updateBackOrderStatus(order, 4)"
                        >Complete Order</a
                      >
                    </a-menu-item> -->
                    <a-menu-item v-if="showDeclinedActions(order)">
                      <a @click="showSureModal(order)">Decline this Order?</a>
                    </a-menu-item>
                    <a-menu-item v-if="showCreateFullfillmentActions(order)">
                      <a @click="handleFulfillmentModal(order)">Create Fulfillments</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </template>

              <template slot="status" slot-scope="data">
                <status-component :status="data"></status-component>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="5">
          <span slot="tab">
            Fulfilling
          </span>
          <div class="requestActions">
            <a-button @click="exportFulfillOrders" style="
                height: 38px;
                border-raduis: 5px;
                background: #418a49;
                color: #fff;
              " icon="export">
              Export
            </a-button>
          </div>
          <div>
            <a-table :columns="columnsStatues" :scroll="{ x: 1500 }" :data-source="tableFulfillingOrdersData" :loading="tableLoading"
              :pagination="pagination" class="tableStyle">
              <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <div slot="filterDistributionCenterDropdown"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <template slot="action" slot-scope="order">
                <a-dropdown>
                  <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                    <a-icon style="font-size: 25px" type="ellipsis" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a @click="showMoreDetailsModal(order)">More Details?</a>
                    </a-menu-item>
                    <!-- <a-menu-item v-if="order.status === 0">
                      <a @click="updateBackOrderStatus(order, 1)"
                        >Move to awaiting confirmation</a
                      >
                    </a-menu-item>
                    <a-menu-item v-else-if="order.status === 1">
                      <a @click="updateBackOrderStatus(order, 2)"
                        >Confrim  Product Line</a
                      >
                    </a-menu-item>
                    <a-menu-item v-else-if="order.status === 2">
                      <a @click="updateBackOrderStatus(order, 3)"
                        >Move to fulfilling</a
                      >
                    </a-menu-item>
                    <a-menu-item v-else-if="order.status === 3">
                      <a @click="updateBackOrderStatus(order, 4)"
                        >Complete Order</a
                      >
                    </a-menu-item> -->
                    <a-menu-item v-if="showDeclinedActions(order)">
                      <a @click="showSureModal(order)">Decline this Order?</a>
                    </a-menu-item>
                    <a-menu-item v-if="showCreateFullfillmentActions(order)">
                      <a @click="handleFulfillmentModal(order)">Create Fulfillments</a>
                    </a-menu-item>
                    <a-menu-item v-if="showCompleteOrderActions(order)">
                      <a @click="updateBackOrderStatus(order, 4)">Complete Order</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </template>

              <template slot="status" slot-scope="data">
                <status-component :status="data"></status-component>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="6">
          <span slot="tab">
            Complete
          </span>
          <div class="requestActions">
            <a-button @click="exportCompleteOrders" style="
                height: 38px;
                border-raduis: 5px;
                background: #418a49;
                color: #fff;
              " icon="export">
              Export
            </a-button>
          </div>
          <div>
            <a-table :columns="columnsStatues" :scroll="{ x: 1500 }" :data-source="tableCompleteOrdersData" :loading="tableLoading"
              :pagination="pagination" class="tableStyle">
              <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <div slot="filterDistributionCenterDropdown"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <template slot="action" slot-scope="order">
                <a-dropdown>
                  <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                    <a-icon style="font-size: 25px" type="ellipsis" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a @click="showMoreDetailsModal(order)">More Details?</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </template>

              <template slot="status" slot-scope="data">
                <status-component :status="data"></status-component>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="7">
          <span slot="tab">
            Canceled
          </span>
          <div class="requestActions">
            <a-button @click="exportCanceledOrders" style="
                height: 38px;
                border-raduis: 5px;
                background: #418a49;
                color: #fff;
              " icon="export">
              Export
            </a-button>
          </div>
          <div>
            <a-table :columns="columnsStatues" :scroll="{ x: 1500 }" :data-source="tableCanceledOrdersData" :loading="tableLoading"
              :pagination="pagination" class="tableStyle">
              <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <div slot="filterDistributionCenterDropdown"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <template slot="action" slot-scope="order">
                <a-dropdown>
                  <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                    <a-icon style="font-size: 25px" type="ellipsis" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a @click="showMoreDetailsModal(order)">More Details?</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </template>

              <template slot="status" slot-scope="data">
                <status-component :status="data"></status-component>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="8">
          <span slot="tab">
            Expired
          </span>
          <div class="requestActions">
            <a-button @click="exportExpiredOrders" style="
                height: 38px;
                border-raduis: 5px;
                background: #418a49;
                color: #fff;
              " icon="export">
              Export
            </a-button>
          </div>
          <div>
            <a-table :columns="columnsStatues" :scroll="{ x: 1500 }" :data-source="tableExpiredOrdersData" :loading="tableLoading"
              :pagination="pagination" class="tableStyle">
              <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <div slot="filterDistributionCenterDropdown"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <template slot="action" slot-scope="order">
                <a-dropdown>
                  <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                    <a-icon style="font-size: 25px" type="ellipsis" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a @click="showMoreDetailsModal(order)">More Details?</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </template>

              <template slot="status" slot-scope="data">
                <status-component :status="data"></status-component>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>

    <a-modal class="modalStyle" :visible="sureVisible" :footer="null" @cancel="handleSureCancel">
      <p style="font-size: 23px;font-weight: bolder;" class="text-center pt-4">{{ displayText }}</p>
      <div class="d-flex justify-content-around pt-5">
        <a-button @click="handleSureCancel" style="
                background: #ff0000f2;
                color: #fff;
                width: 30%;
                border-radius: 5px;
                border: 1px solid #ff0000f2;
              ">
          No
        </a-button>
        <a-button @click="handleCancelOrder" style="
          background: #418a49;
          color: #fff;
          width: 30%;
          border-radius: 5px;
          border: 1px solid #418a49;
        ">
          Yes
        </a-button>
      </div>
    </a-modal>

    <a-modal class="modalStyle" :visible="addBackOrderVisible" width="600px" :footer="null"
      @cancel="handleAddBackOrderCancel">
      <h3 style="
          display: flex;
          justify-content: center;
          font-weight: bolder;
          padding-top: 10px;
          padding-bottom: 30px;
        ">
        Add New Quotation
      </h3>
      <div>
        <a-form-model ref="addBackOrderForm" :model="addBackOrderModel" :rules="rules">
          <a-row>
            <a-col :span="22" :offset="1">
              <a-form-model-item label="Retailers" ref="retailerId" prop="retailerId">
                <a-select v-model="addBackOrderModel.retailerId" placeholder="please select your retailer">
                  <a-select-option v-for="retailer in availableRetailers" :key="retailer.locationId"
                    v-bind:value="retailer.locationId">
                    {{ retailer.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <div ref="productHeight" style="height: 200px; overflow-y: scroll">
            <a-row v-for="(request, index) in addBackOrderModel.request" :key="request.key" type="flex"
              justify="space-around">
              <a-col :span="7" :offset="1">
                <a-form-model-item label="Product Name" :prop="'request.' + index + '.productId'" :rules="{
          required: true,
          message: 'Please choose your option',
          trigger: 'change',
        }">
                  <a-select show-search placeholder="Choose your product" option-filter-prop="children"
                    v-model="request.productId" :filter-option="filterOption">
                    <a-select-option v-for="product in availableClientProducts" :key="product.id"
                      v-bind:value="product.id">
                      {{ product.brandName }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="7" :offset="1">
                <a-form-model-item label="Quantity" :prop="'request.' + index + '.quantity'" :rules="{
          required: true,
          message: 'Please enter your quantity',
          trigger: 'change',
        }">
                  <a-input-number :min="1" class="rightSideinputText" type="number" v-model="request.quantity" />
                </a-form-model-item>
              </a-col>
              <a-col :span="7" :offset="1">
                <div style="
                    margin-top: 53px;
                    display: flex;
                    justify-content: space-around;
                  ">
                  <a-icon v-if="addBackOrderModel.request.length > 1" class="dynamic-delete-button"
                    type="minus-circle-o" :disabled="addBackOrderModel.request.length === 1"
                    @click="removeDomain(request)" />
                </div>
              </a-col>
            </a-row>
          </div>

          <a-form-model-item class="pt-4">
            <a-button style="
                margin: 0 auto;
                float: right;
                background: #418a49;
                color: #fff;
              " @click="addDomain">
              <a-icon type="plus" /> Add Product
            </a-button>
          </a-form-model-item>
          <a-row>
            <a-col :span="22" :offset="1">
              <a-form-model-item label="Notes" ref="notes" prop="notes">
                <a-textarea v-model="addBackOrderModel.notes" placeholder="Enter notes...."
                  :auto-size="{ minRows: 3, maxRows: 5 }" />
              </a-form-model-item>
            </a-col>
          </a-row>

          <div style="display: flex; justify-content: center; padding-bottom: 10px">
            <!-- <a-spin class="spinner" :spinning="loading" /> -->
          </div>

          <a-form-model-item style="
              display: flex;
              justify-content: center;
              align-items: center;
              padding-top: 40px;
            ">
            <a-button @click="handleAddBackOrderSubmit" :loading="loading" style="
                background: #418a49;
                height: 59px;
                color: #fff;
                width: 263px;
                border-radius: 5px;
              ">
              Proceed
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
    <a-modal :visible="showFulfillmentCreateModal" @cancel="cancelModal" :footer="null" width="800px">
      <a-spin :spinning="loading">
        <h3 style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;padding-bottom:30px">
          Create
          Fulfillment</h3>
        <create-fulfillment-form :data="data" @inventoryRequest="handleCreateFullment"></create-fulfillment-form>
      </a-spin>
    </a-modal>
    
    </a-card>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";
import XLSX from "xlsx";
import StatusComponent from "../shared-components/StatusComponent.vue";
import CreateFulfillmentForm from './modal/CreateFulfillmentForm.vue'

const columns = [
  {
    title: "Order Number",
    width: 200,
    key: "id",
    dataIndex: "id",
  },
  {
    title: "Retailer Name",
    dataIndex: "retailerName",
    key: "retailerName",
    scopedSlots: {
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
    },
    width: 200,
    onFilter: (value, record) =>
      record.retailerName
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    // width: 150,
  },
  {
    title: "Distribution Center",
    dataIndex: "distributionCenter",
    scopedSlots: {
      filterDropdown: 'filterDistributionCenterDropdown',
      filterIcon: 'filterIcon',
    },
    width: 200,
    onFilter: (value, record) =>
      record.distributionCenter
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    // width: 200,
  },
  {
    title: "Amount(Ksh)",
    dataIndex: "amount",
    key: "amount",
    width: 200,
  },
  {
    title: "Due Date",
    dataIndex: "dueDate",
    key: "dueDate",
    width: 200,
  },
  {
    title: "Delivered To",
    dataIndex: "deliverTo",
    key: "deliverTo",
    width: 200,
  },

  {
    title: "Ordered Date",
    dataIndex: "dateCreated",
    key: "dateCreated",
    width: 200,
  },
  {
    title: "Status",
    key: "status",
    dataIndex: "status",
    scopedSlots: {
      customRender: "status",
      filterDropdown: 'filterStatusDropdown',
      filterIcon: 'filterIcon',
    },
    width: 200,
    onFilter: (value, record) =>
      record.status
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),

  },
  {
    title: "Action",
    key: "action",
    width: 150,
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
  },
];

const columnsStatues = [
  {
    title: "Order Number",
    width: 200,
    key: "id",
    dataIndex: "id",
  },
  {
    title: "Retailer Name",
    dataIndex: "retailerName",
    key: "retailerName",
    scopedSlots: {
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
    },
    width: 200,
    onFilter: (value, record) =>
      record.retailerName
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    // width: 150,
  },
  {
    title: "Distribution Center",
    dataIndex: "distributionCenter",
    scopedSlots: {
      filterDropdown: 'filterDistributionCenterDropdown',
      filterIcon: 'filterIcon',
    },
    width: 200,
    onFilter: (value, record) =>
      record.distributionCenter
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    // width: 200,
  },
  {
    title: "Amount(Ksh)",
    dataIndex: "amount",
    key: "amount",
     width: 200,
  },

  {
    title: "Due Date",
    dataIndex: "dueDate",
    key: "dueDate",
    width: 200,
  },
  {
    title: "Delivered To",
    dataIndex: "deliverTo",
    key: "deliverTo",
    width: 200,
  },

  {
    title: "Ordered Date",
    dataIndex: "dateCreated",
    key: "dateCreated",
    width: 200,
  },
  {
    title: "Status",
    key: "status",
    dataIndex: "status",
    width: 200,
    scopedSlots: { customRender: "status" },
  },
  {
    title: "Action",
    key: "action",
    dataIndex: "action",
    width: 150,
    scopedSlots: { customRender: "action" },
  },
];

export default {
  name: "ViewBackOrders",
  components: {
    StatusComponent,
    CreateFulfillmentForm
  },
  data() {
    return {
      dateFormat: "YYYY-MM-DD",
      startDate: moment()
        .subtract(1, "months")
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: moment().add(1, "d").format("YYYY-MM-DD"),
      searchText: "",
      columns,
      columnsStatues,
      product: {},
      tableAllOrdersData: [],
      tableNewOrdersData: [],
      tableFulfillingOrdersData: [],
      tableExpiredOrdersData: [],
      tableAwaitingConfirmationOrdersData: [],
      tableFirmedOrdersData: [],
      tableReceivedOrdersData: [],
      tableCompleteOrdersData: [],
      tableCanceledOrdersData: [],
      availableRetailers: [],
      availableClientProducts: [],
      exportLoading: false,
      sureVisible: false,
      addBackOrderVisible: false,
      currentFulfillmentLine: null,
      pagination: {
        pageSize: 20,
      },
      fulfillments: {
        requests: [
          {
            id: "",
            productBrandName: "",
            productId: 2,
            key: Date.now(),
            qty: 1,
            quantity: 12,
            disabled: false,
          },
        ],
      },
      params: {
        page: -1,
        perPage: -1,
        searchBy: {},
        sortBy: {},
      },
      addBackOrderModel: {
        request: [
          {
            productId: "",
            quantity: "",
            key: Date.now(),
          },
        ],
        notes: "",
        retailerId: "",
      },
      searchInput: null,
      searchedColumn: '',
      displayText: "",
      selectedOrder: {},
      productId: "",
      loading: false,
      availableBackOrders: [],
      data: {},
      tableLoading: false,
      showFulfillmentCreateModal: false,
      expectedDate: null,
      rules: {
        retailerId: [
          {
            required: true,
            message: "Please choose your option",
            trigger: "change",
          },
        ],
        retailerProductIds: [
          {
            required: true,
            message: "Please choose your options",
            trigger: "change",
          },
        ],
        quantity: [
          {
            required: true,
            message: "Please enter your quantity",
            trigger: "change",
          },
          {
            pattern: new RegExp(/^[1-9]\d*$/),
            message: "Please enter valid number",
            trigger: "change",
          },
        ],
        sellingPrice: [
          {
            required: true,
            message: "Please enter selling price",
            trigger: "change",
          },
          {
            pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
            message: "Please enter valid number",
            trigger: "change",
          },
        ],
        purchasePrice: [
          {
            required: true,
            message: "Please enter purchase price",
            trigger: "change",
          },
          {
            pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),
            message: "Please enter valid number",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    displayTotalOrders() {
      return this.tableAllOrdersData.length;
    },
    displayTotalNewOrders() {
      return this.tableNewOrdersData.length;
    },
    displayTotalFulfillingOrders() {
      return this.tableFulfillingOrdersData.length;
    },
    displayTotalAwaitingConfrimationOrders() {
      return this.tableAwaitingConfirmationOrdersData.length;
    },
    displayCompleteOrders() {
      return this.tableCompleteOrdersData.length;
    },
    displayRecievedOrders() {
      return this.tableReceivedOrdersData.length;
    },
    displayFirmedOrders() {
      return this.tableFirmedOrdersData.length;
    },
    displayCanceledOrders() {
      return this.tableCanceledOrdersData.length;
    },
    displayExpiredOrders() {
      return this.tableExpiredOrdersData.length;
    },
  },
  methods: {
    ...mapActions([
      "getBackOrdersData",
      "getRetailerAndProducts",
      "updateBackOrder",
      "addBackOrder",
      "setBackOrderInfo",
    ]),
    moment,
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = '';
    },
    handleSureCancel() {
      this.sureVisible = false
    },
    showSureModal(data) {
      this.selectedOrder = data
      this.displayText = `Are you sure, you want to decline this order #${data.id}`
      this.sureVisible = true
    },
    handleCancelOrder() {
      this.updateBackOrderStatus(this.selectedOrder, 5)
      this.sureVisible = false
    },
    showMoreDetailsModal(order) {
      this.setBackOrderInfo(order);
      this.$router.push(`/back-order-details`).catch(() => { });
    },
    showSuccessAlert(message) {
      this.$notification["success"]({
        message: message,
      });
    },
    showErrorAlert(message) {
      this.$notification["error"]({
        message: message,
      });
    },
    dateChangeHandler(dateString) {
      this.expectedDate = moment(dateString);
    },
    handleFulfillmentModal(order) {
      // console.log("order |", order)
      this.data = {
        id: order.id,
        data: order.backOrderLines.map(product => ({
          productId: product.productId,
          productName: product.productBrandName,
          quantity: product.quantity,
        }))
      }
      // console.log("data |", this.data)
      this.showFulfillmentCreateModal = true;
    },
    cancelModal() {
      this.showFulfillmentCreateModal = false;
    },
    handleQuantityChange(fulfillment) {
      // console.log(fulfillment);
      if (fulfillment.qty > fulfillment.quantity) {
        this.showErrorAlert(
          `Sorry you have exceeded the maximum quantity of kindly choose between 1 to ${fulfillment.quantity}`
        );
      }
    },
    removeFulfillment(item) {
      let index = this.fulfillments.requests.indexOf(item);
      if (index !== -1) {
        item.disabled = true;
      }
    },
    addFulfillment(fulfillment) {
      fulfillment.disabled = false;
    },

    async handleCreateFullment(data) {
      this.loading = true
      const response = await this.$store.dispatch("fulfillments/CreateBackOrderFulfillments", data);
      this.loading = false
      if (response.status == 200) {
        this.showFulfillmentCreateModal = false;
        this.showSuccessAlert("Fulfillment Created Successfully")
        this.loadBackOrdersData()
      } else {
        this.showErrorAlert(response.data.messages)
      }
    },

    exportAllOrders() {
      // console.log("tableAllOrdersData | ", this.tableAllOrdersData)
      const dataToExport = [
        [
          "Order Number",
          "Retailer Name",
          "Amount(Ksh)",
          "Distribution Centre Name",
          "Ordered Date",
          "Status",
        ],
      ];
      this.tableAllOrdersData.forEach((v) => {
        dataToExport.push([
          v.id,
          v.retailerName,
          v.amount,
          v.distributionCenter,
          v.dateCreated,
          v.status,
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export-Quotation-${moment().format("DD-MM-YYYY")}.xlsx`
      );
      this.showSuccessAlert("Data Successfully Exported");
    },
    exportNewOrders() {
      const dataToExport = [
        [
          "Order Number",
          "Retailer Name",
          "Amount(Ksh)",
          "Distribution Centre Name",
          "Ordered Date",
          "Status",
        ],
      ];
      this.tableNewOrdersData.forEach((v) => {
        dataToExport.push([
          v.id,
          v.retailerName,
          v.amount,
          v.distributionCenter,
          v.dateCreated,
          v.status,
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export-New-Back-Orders-${moment().format("DD-MM-YYYY")}.xlsx`
      );
      this.showSuccessAlert("Data Successfully Exported");
    },
    exportFulfillOrders() {
      const dataToExport = [
        [
          "Order Number",
          "Retailer Name",
          "Amount(Ksh)",
          "Distribution Centre Name",
          "Ordered Date",
          "Status",
        ],
      ];
      this.tableFulfillingOrdersData.forEach((v) => {
        dataToExport.push([
          v.id,
          v.retailerName,
          v.amount,
          v.distributionCenter,
          v.dateCreated,
          v.status,
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export-Fulfilling-Back-Orders-${moment().format("DD-MM-YYYY")}.xlsx`
      );
      this.showSuccessAlert("Data Successfully Exported");
    },
    exportAwaitingConfrimation() {
      const dataToExport = [
        [
          "Order Number",
          "Retailer Name",
          "Amount(Ksh)",
          "Distribution Centre Name",
          "Ordered Date",
          "Status",
        ],
      ];
      this.tableAwaitingConfirmationOrdersData.forEach((v) => {
        dataToExport.push([
          v.id,
          v.retailerName,
          v.amount,
          v.distributionCenter,
          v.dateCreated,
          v.status,
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export-Awaiting-Confirmation-Back-Orders-${moment().format(
          "DD-MM-YYYY"
        )}.xlsx`
      );
      this.showSuccessAlert("Data Successfully Exported");
    },
    exportCompleteOrders() {
      const dataToExport = [
        [
          "Order Number",
          "Retailer Name",
          "Amount(Ksh)",
          "Distribution Centre Name",
          "Ordered Date",
          "Status",
        ],
      ];
      this.tableCompleteOrdersData.forEach((v) => {
        dataToExport.push([
          v.id,
          v.retailerName,
          v.amount,
          v.distributionCenter,
          v.dateCreated,
          v.status,
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export-Complete-Back-Orders-${moment().format("DD-MM-YYYY")}.xlsx`
      );
      this.showSuccessAlert("Data Successfully Exported");
    },
    exportReceivedOrders() {
      const dataToExport = [
        [
          "Order Number",
          "Retailer Name",
          "Amount(Ksh)",
          "Distribution Centre Name",
          "Ordered Date",
          "Status",
        ],
      ];
      this.tableReceivedOrdersData.forEach((v) => {
        dataToExport.push([
          v.id,
          v.retailerName,
          v.amount,
          v.distributionCenter,
          v.dateCreated,
          v.status,
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export-Received-Back-Orders-${moment().format("DD-MM-YYYY")}.xlsx`
      );
      this.showSuccessAlert("Data Successfully Exported");
    },
    exportFirmedOrders() {
      const dataToExport = [
        [
          "Order Number",
          "Retailer Name",
          "Amount(Ksh)",
          "Distribution Centre Name",
          "Ordered Date",
          "Status",
        ],
      ];
      this.tableFirmedOrdersData.forEach((v) => {
        dataToExport.push([
          v.id,
          v.retailerName,
          v.amount,
          v.distributionCenter,
          v.dateCreated,
          v.status,
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export-Firmed-Back-Orders-${moment().format("DD-MM-YYYY")}.xlsx`
      );
      this.showSuccessAlert("Data Successfully Exported");
    },
    exportCanceledOrders() {
      const dataToExport = [
        [
          "Order Number",
          "Retailer Name",
          "Amount(Ksh)",
          "Distribution Centre Name",
          "Ordered Date",
          "Status",
        ],
      ];
      this.tableCanceledOrdersData.forEach((v) => {
        dataToExport.push([
          v.id,
          v.retailerName,
          v.amount,
          v.distributionCenter,
          v.dateCreated,
          v.status,
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export-Canceled-Back-Orders-${moment().format("DD-MM-YYYY")}.xlsx`
      );
      this.showSuccessAlert("Data Successfully Exported");
    },
    exportExpiredOrders() {
      const dataToExport = [
        [
          "Order Number",
          "Retailer Name",
          "Amount(Ksh)",
          "Distribution Centre Name",
          "Ordered Date",
          "Status",
        ],
      ];
      this.tableExpiredOrdersData.forEach((v) => {
        dataToExport.push([
          v.id,
          v.retailerName,
          v.amount,
          v.distributionCenter,
          v.dateCreated,
          v.status,
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export-Expired-Back-Orders-${moment().format("DD-MM-YYYY")}.xlsx`
      );
      this.showSuccessAlert("Data Successfully Exported");
    },
    async updateBackOrderStatus(order, status) {
      this.tableLoading = true;
      const request = {
        backOrderId: order.id,
        data: {
          status,
        },
      };
      const response = await this.updateBackOrder(request);
      this.tableLoading = false;
      if (response.status === 200) {
        this.loadBackOrdersData();
        this.showSuccessAlert(`Back Order Canceled Successfully`);
      } else {
        this.tableLoading = false;
        // console.log("Error | ", response);
      }
    },
    showAddBackOrderModal() {
      // this.$router.push('/request-product').catch(()=>{});
      this.addBackOrderVisible = true;
    },
    addDomain() {
      this.addBackOrderModel.request.push({
        productId: "",
        quantity: "",
        key: Date.now(),
      });
      this.scrollToEnd();
    },
    scrollToEnd: function () {
      const container = this.$refs.productHeight;
      container.scrollTop = container.scrollHeight;
    },
    removeDomain(item) {
      let index = this.addBackOrderModel.request.indexOf(item);
      if (index !== -1) {
        this.addBackOrderModel.request.splice(index, 1);
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleAddBackOrderCancel() {
      this.addBackOrderVisible = false;
    },
    onInventoryChange(value, clearFilters) {
      let result = []
      if (value === 'all') {
        result = this.availableBackOrders
      } else {
        result = this.availableBackOrders.filter(invoice => parseInt(invoice.status) === parseInt(value))
      }
      this.tableAllOrdersData = result.map((order) => ({
        key: order.id,
        id: `#${order.id}`,
        distributionCenter: order.sourceLocationName,
        retailerName: order.destinationLocationName,
        amount: order.total.toLocaleString(undefined, {
          minimumFractionDigits: 2,
        }),
        dateCreated: moment(order.createdAt).format("DD-MMM-YYYY"),
        status: order.statusLabel,
        action: order,
      }));
      clearFilters();
    },
    getAllBackOrders(response) {
      if (response.status === 200) {
        this.tableAllOrdersData = [];
        this.availableBackOrders = response.data.data;
        this.tableAllOrdersData = response.data.data.map((order) => ({
          key: order.id,
          id: `#${order.id}`,
          distributionCenter: order.sourceLocationName,
          retailerName: order.destinationLocationName,
          amount: order.total.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          }),
          dateCreated: moment(order.createdAt).format("DD-MMM-YYYY"),
          dueDate: order.dueDate ? moment(order.dueDate).format("DD-MMM-YYYY") : 'N/A',
          deliverTo: order.deliverTo ? order.deliverTo  : 'N/A',
          status: order.statusLabel,
          action: order,
        }));
      } else {
        // console.log("Error | ", response);
      }
    },
    getNewBackOrders(response) {
      if (response.status === 200) {
        this.tableNewOrdersData = [];
        response.data.data.forEach((order) => {
          if (order.statusLabel === "New") {
            this.tableNewOrdersData.push({
              key: order.id,
              id: `#${order.id}`,
              distributionCenter: order.sourceLocationName,
              retailerName: order.destinationLocationName,
              amount: order.total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
              }),
              dateCreated: moment(order.createdAt).format("DD-MMM-YYYY"),
              dueDate: order.dueDate ? moment(order.dueDate).format("DD-MMM-YYYY") : 'N/A',
              deliverTo: order.deliverTo ? order.deliverTo  : 'N/A',
              status: order.statusLabel,
              action: order,
            });
          }
        });
      } else {
        // console.log("Error | ", response);
      }
    },
    getFulfillingBackOrders(response) {
      if (response.status === 200) {
        this.tableFulfillingOrdersData = [];
        response.data.data.forEach((order) => {
          if (order.statusLabel === "Fulfilling") {
            this.tableFulfillingOrdersData.push({
              key: order.id,
              id: `#${order.id}`,
              distributionCenter: order.sourceLocationName,
              retailerName: order.destinationLocationName,
              amount: order.total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
              }),
              dateCreated: moment(order.createdAt).format("DD-MMM-YYYY"),
              dueDate: order.dueDate ? moment(order.dueDate).format("DD-MMM-YYYY") : 'N/A',
              deliverTo: order.deliverTo ? order.deliverTo  : 'N/A',
              status: order.statusLabel,
              action: order,
            });
          }
        });
      } else {
        // console.log("Error | ", response);
      }
    },
    getAwaitingConfrimationBackOrders(response) {
      if (response.status === 200) {
        this.tableAwaitingConfirmationOrdersData = [];
        response.data.data.forEach((order) => {
          if (order.statusLabel === "AwaitingConfirmation") {
            this.tableAwaitingConfirmationOrdersData.push({
              key: order.id,
              id: `#${order.id}`,
              distributionCenter: order.sourceLocationName,
              retailerName: order.destinationLocationName,
              amount: order.total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
              }),
              dateCreated: moment(order.createdAt).format("DD-MMM-YYYY"),
              dueDate: order.dueDate ? moment(order.dueDate).format("DD-MMM-YYYY") : 'N/A',
              deliverTo: order.deliverTo ? order.deliverTo  : 'N/A',
              status: order.statusLabel,
              action: order,
            });
          }
        });
      } else {
        // console.log("Error | ", response);
      }
    },
    getCompleteBackOrders(response) {
      if (response.status === 200) {
        this.tableCompleteOrdersData = [];
        response.data.data.forEach((order) => {
          if (order.statusLabel === "Complete") {
            this.tableCompleteOrdersData.push({
              key: order.id,
              id: `#${order.id}`,
              distributionCenter: order.sourceLocationName,
              retailerName: order.destinationLocationName,
              amount: order.total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
              }),
              dateCreated: moment(order.createdAt).format("DD-MMM-YYYY"),
              dueDate: order.dueDate ? moment(order.dueDate).format("DD-MMM-YYYY") : 'N/A',
              deliverTo: order.deliverTo ? order.deliverTo  : 'N/A',
              status: order.statusLabel,
              action: order,
            });
          }
        });
      } else {
        // console.log("Error | ", response);
      }
    },
    getReceivedBackOrders(response) {
      if (response.status === 200) {
        this.tableReceivedOrdersData = [];
        response.data.data.forEach((order) => {
          if (order.statusLabel === "Received") {
            this.tableReceivedOrdersData.push({
              key: order.id,
              id: `#${order.id}`,
              distributionCenter: order.sourceLocationName,
              retailerName: order.destinationLocationName,
              amount: order.total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
              }),
              dateCreated: moment(order.createdAt).format("DD-MMM-YYYY"),
              dueDate: order.dueDate ? moment(order.dueDate).format("DD-MMM-YYYY") : 'N/A',
              deliverTo: order.deliverTo ? order.deliverTo  : 'N/A',
              status: order.statusLabel,
              action: order,
            });
          }
        });
      } else {
        // console.log("Error | ", response);
      }
    },
    getFirmedBackOrders(response) {
      if (response.status === 200) {
        this.tableFirmedOrdersData = [];
        response.data.data.forEach((order) => {
          if (order.statusLabel === "Firmed") {
            this.tableFirmedOrdersData.push({
              key: order.id,
              id: `#${order.id}`,
              distributionCenter: order.sourceLocationName,
              retailerName: order.destinationLocationName,
              amount: order.total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
              }),
              dateCreated: moment(order.createdAt).format("DD-MMM-YYYY"),
              dueDate: order.dueDate ? moment(order.dueDate).format("DD-MMM-YYYY") : 'N/A',
              deliverTo: order.deliverTo ? order.deliverTo  : 'N/A',
              status: order.statusLabel,
              action: order,
            });
          }
        });
      } else {
        // console.log("Error | ", response);
      }
    },
    getCancelledBackOrders(response) {
      if (response.status === 200) {
        this.tableCanceledOrdersData = [];
        response.data.data.forEach((order) => {
          //    order.statusLabel = 'Canceled'
          if (order.statusLabel === "Canceled") {
            this.tableCanceledOrdersData.push({
              key: order.id,
              id: `#${order.id}`,
              distributionCenter: order.sourceLocationName,
              retailerName: order.destinationLocationName,
              amount: order.total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
              }),
              dateCreated: moment(order.createdAt).format("DD-MMM-YYYY"),
              dueDate: order.dueDate ? moment(order.dueDate).format("DD-MMM-YYYY") : 'N/A',
              deliverTo: order.deliverTo ? order.deliverTo  : 'N/A',
              status: order.statusLabel,
              action: order,
            });
          }
        });
      } else {
        // console.log("Error | ", response);
      }
    },
    getExpiredBackOrders(response) {
      if (response.status === 200) {
        this.tableCanceledOrdersData = [];
        response.data.data.forEach((order) => {
          //    order.statusLabel = 'Expired'
          if (order.statusLabel === "Expired") {
            this.tableExpiredOrdersData.push({
              key: order.id,
              id: `#${order.id}`,
              distributionCenter: order.sourceLocationName,
              retailerName: order.destinationLocationName,
              amount: order.total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
              }),
              dateCreated: moment(order.createdAt).format("DD-MMM-YYYY"),
              dueDate: order.dueDate ? moment(order.dueDate).format("DD-MMM-YYYY") : 'N/A',
              deliverTo: order.deliverTo ? order.deliverTo  : 'N/A',
              status: order.statusLabel,
              action: order,
            });
          }
        });
      } else {
        // console.log("Error | ", response);
      }
    },
    showDeclinedActions(data) {
      const allowedDeclincedStatus = [
        "New",
        "AwaitingConfirmation",
        "Received",
        "Firmed",
        "Fulfilling",
      ];
      const result = allowedDeclincedStatus.includes(data.statusLabel)
        ? true
        : false;
      return result;
    },
    showCreateFullfillmentActions(data) {
      const allowedDeclincedStatus = [
        "Firmed",
        "Fulfilling",
      ];
      const result = allowedDeclincedStatus.includes(data.statusLabel)
        ? true
        : false;
      return result;
    },
    showCompleteOrderActions(data) {
      const allowedDeclincedStatus = [
        "Fulfilling",
      ];
      const result = allowedDeclincedStatus.includes(data.statusLabel)
        ? true
        : false;
      return result;
    },
    async loadBackOrdersData() {
      this.tableLoading = true;
      const response = await this.getBackOrdersData();
      this.getAllBackOrders(response);
      this.getNewBackOrders(response);
      this.getFulfillingBackOrders(response);
      this.getAwaitingConfrimationBackOrders(response);
      this.getCompleteBackOrders(response);
      this.getReceivedBackOrders(response);
      this.getFirmedBackOrders(response);
      this.getCancelledBackOrders(response);
      this.getExpiredBackOrders(response);

      this.tableLoading = false;
    },
    handleAddBackOrderSubmit() {
      this.$refs.addBackOrderForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let productQuantity = {};

          this.addBackOrderModel.request.forEach((product) => {
            productQuantity[product.productId] = product.quantity;
          });
          const request = {
            // sourceLocationId: parseInt(process.env.VUE_APP_SOURCE_LOCATION_ID),
            sourceLocationId: 1140,
            destinationLocationId: this.addBackOrderModel.retailerId,
            productAndQuantity: productQuantity,
            notes: this.addBackOrderModel.notes,
          };

          this.addBackOrder(request).then(
            (response) => {
              this.loading = false;
              if (response.status === 200) {
                this.loadBackOrdersData();
                this.showSuccessAlert("New Back Order Created Successfully");
                this.$refs.addBackOrderForm.resetFields();
                this.addBackOrderVisible = false;
              } else {
                this.showErrorAlert(response.data.messages);
              }
            },
            (error) => {
              this.loading = false;
              this.showErrorAlert(JSON.stringify(error));
            }
          );
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    getAllClientsProducts(response) {
      if (response.status === 200) {
        this.availableClientProducts = response.data.data;
      } else {
        // console.log("Error | ", response);
      }
    },

    getAllRetailersProducts(response) {
      if (response.status === 200) {
        this.availableRetailers = response.data.data;
      } else {
        // console.log("Error | ", response);
      }
    },
    async loadRetailerAndProducts(request_data) {
      let response = await this.getRetailerAndProducts(request_data);
      this.getAllClientsProducts(response[0]);
      this.getAllRetailersProducts(response[1]);
    },
  },
  created() {
    if (this.loadRetailerAndProducts) {
      this.loadRetailerAndProducts(this.params);
    }
    if (this.loadBackOrdersData) {
      this.loadBackOrdersData();
    }
  },
};
</script>

<style scoped>
.ant-table-wrapper {
  zoom: 1;
  background: #fff;
  margin-bottom: 30px;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

a {
  color: #418a49;
}

a:hover {
  color: #418a49;
}

.rightSideinputText {
  width: 100%;
  border-radius: 5px;
}

.requestActions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

card-container {
  background: none;
  overflow: hidden;
  /* padding: 24px; */
}

.disabledIcon {
  opacity: 0.5;
  cursor: not-allowed;
}

.card-container>.ant-tabs-card>.ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  height: 40px;
  color: #98c14b;
  background: #e5efe7;
  border-color: #e5efe7;
  border-bottom: 1px solid #98c14b;
}

.card-container>>>.ant-tabs-tab {
  height: 40px;
  margin: 0;
  width: 217px;
  margin-right: 2px;
  padding: 0 16px;
  line-height: 38px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
}

.card-container>>>.ant-tabs-tab:hover {
  color: #98c14b;
  /* background: #e5efe7; */
}

.card-container>>>.ant-badge-count {
  z-index: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  color: #fff;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #98c14b;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar {
  border-color: #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
  border-color: #e5efe7;
  background: #e5efe7;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.actionIcons {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
.tableStyle >>> .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background: #26A246;
    color: #fff;
  
}


.tableStyle >>> .ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle >>> .ant-table-header  {
    background: #fff !important;
}

.card-container>>>.ant-tabs-card>.ant-tabs-bar {
  border: none;
}

.card-container>>>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
  height: 40px;
  color: #111827;
  background: transparent;
  border-radius: 6px;
}


.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  height: 40px;
  color: #fff;
  background: #418a49;
  border-bottom: none;
  border-radius: 6px;
}
</style>